import styled from 'styled-components'
import { Link } from 'react-router-dom';
import { mainColor, mainFont } from '../../styles/global';

export const MoneyManagementWrapper = styled.div`
    padding:3rem 5%;

`;

export const MoneyManagementHeader = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    gap:3rem;
    height:72vh;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap:0rem;
        height:50vh;
    }
`;
export const RightSection = styled.div`
    flex:0.5;
    img{
        height:90%;
        width:90%;
    }
    @media screen and (max-width: 768px) {
        img{
            height:100%;
            width:100%;
        }
    }

`;
export const  LeftSection = styled.div`
    flex:0.5;

    h3{
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 600;
        font-size: 46.5434px;
        line-height: 60px;
        letter-spacing: 0.01em;
        color:${mainColor};
    }
    @media screen and (max-width: 768px) {
        h3{
            font-weight: 500;
            font-size: 27px;
            line-height: 33px;
        }
    }

`;
export const  NavLink = styled(Link)`
        background: #090458;
        border: 2px solid #090458;
        border-radius: 9px;
        color:#fff;
        text-decoration: none;
        // padding: 18px 60px;
        padding: 15px 30px;
        

`;
export const TextBox = styled.div`
    margin:auto;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-direction: column;
`;

export const MoneyManagementTextSection = styled.div`
      
        p{
            font-family: ${mainFont};
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 29px;
            text-align: justify;
            letter-spacing: 0.01em;
            color: #8D8D8D;
            width:80%;
        }
        @media screen and (max-width: 768px) {
            p{
                font-size: 12px;
                line-height: 15px;
            }
        }
`;

export const MoneyManagementTextHeader = styled.div`
        font-family: ${mainFont};
        font-style: normal;
        font-weight: 500;
        font-size: 46.5434px;
        width:70%;
        text-align: justify;
        letter-spacing: 0.01em;
        color: ${mainColor};
        margin:4rem auto 2rem auto;
        @media screen and (max-width: 768px) {
            font-weight: 600;
            width:90%;
            font-size: 18px;
            line-height: 34px;
            text-align: justify;
            margin:4rem auto 2rem auto;

        }
`;
export const MoneyManagementGridBox = styled.div`
        display:flex;
        justify-content:center;
        align-items: center;
        gap:2rem;
        flex-wrap: wrap;
        margin-top:4rem;
        @media screen and (max-width: 768px) {
            flex-direction: column;
        }

`;
export const StoryBox = styled.div`
        width:calc(50% - 2rem);
        height:350px;
        padding:5% 3%;
        background:#FDF2F5;
        display:flex;
        justify-content:center;
        align-items: center;
        position:relative;
        border-radius: 9px;
        margin-top:30px;

        >div{
            border:1px solid black;
            padding:5px;
            height:60px;
            width:60px;
            border-radius:60px;
            background:#fff;
            display:flex;
            justify-content:center;
            align-items: center;
            position: absolute;
            top: -0;
            left:50%;
            transform: translate(-50%, -50%);
        }
        p{
            font-family: 'Avenir';
            font-style: normal;
            font-weight: 400;
            font-size: 17px;
            line-height: 26px;
            text-align: justify;
            letter-spacing: 0.01em;
            color: #8D8D8D;
        }
        @media screen and (max-width: 768px) {
            width:100%;
            height:200px;
            > div{
                height:50px;
                width:50px;
                border-radius:50px;
            }
            p{
                font-family: 'Avenir LT Std';
                font-style: normal;
                font-weight: 400;
                font-size: 10.1319px;
                line-height: 15px;
                text-align: justify;
                letter-spacing: 0.01em;
                color: #8D8D8D;
            }
        }

`;
